var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-8 q-px-md h-auto"},[_c('TradingView'),_c('TransactionsMain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }